<template>
  <div class="accordion-section critical-component-clear">
    <div class="container">
      <div class="grid">
        <div
          v-if="title"
          class="accordion-section__header col xs-span l2-11"
        >
          <h2
            class="accordion-section__title text-heading-xl text-heading-3xl-desktop"
            v-text="title"
          />
        </div>

        <div
          v-if="blocks.length"
          class="accordion-section__main col xs-span l2-11"
        >
          <base-accordion
            :default-index="false"
            multiple
          >
            <base-accordion-item
              v-for="(block, index) of blocks"
              :key="`${block.title}-${index}`"
              :name="block.title"
            >
              <template #headerLabel>
                <span
                  class="text-heading-s text-heading-m-desktop"
                  v-text="block.title"
                />
              </template>

              <div
                class="
                  accordion-section__accordion-body
                  rte
                  text-body-s-regular
                "
                v-html="block.body"
              />
            </base-accordion-item>
          </base-accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAccordionItem from '~async/base-accordion/base-accordion-item'
import BaseAccordion from '~async/base-accordion/base-accordion'

/**
 * Vue: Accordion section (accordion-section)
 * -----------------------------------------------------------------------------
 * A section containing accordions.
 * - Component settings: section / dynamic / async / scroll
 *
 * @param {String} title - Section title.
 * @param {Array} blocks - Array of accordion data.
 *
 */
export default {
  name: 'AccordionSection',
  components: { BaseAccordion, BaseAccordionItem },

  props: {
    title: {
      type: String,
      default: '',
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './accordion-section';
</style>
